import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { DateTimeModalComponent } from './date-time-modal/date-time-modal.component';
import { DocumentUploadSelectComponent } from './document-upload-select/document-upload-select.component';
import { DocumentsUploadComponent } from './documents-upload/documents-upload.component';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  declarations: [
    DateTimeModalComponent,
    DocumentUploadSelectComponent,
    DocumentsUploadComponent,
  ],
  exports: [DocumentsUploadComponent, DocumentUploadSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    DatePickerModule,
    ConfirmDialogModule,
    DialogModule,
    InputTextModule,
    MultiSelectModule,
    TableModule,
    TooltipModule,
  ],
})
export class DocumentsUploadModule {}
